/** Providers bill in USD; everything here is shown in NT$ at a rate the reader can adjust. */
export const DEFAULT_TWD_PER_USD = 32;

/** Drafts cost small change, so sub-dollar sums keep more decimals than money usually does. */
export function formatTwd(costUsd: number, rate: number = DEFAULT_TWD_PER_USD): string {
  const twd = costUsd * rate;
  if (twd === 0) return "NT$0";
  if (twd < 1) return `NT$${twd.toFixed(2)}`;
  if (twd < 10) return `NT$${twd.toFixed(1)}`;
  return `NT$${Math.round(twd).toLocaleString()}`;
}

export function formatTokens(tokens: number): string {
  if (tokens < 1000) return String(tokens);
  if (tokens < 1_000_000) return `${(tokens / 1000).toFixed(1)}k`;
  return `${(tokens / 1_000_000).toFixed(2)}M`;
}

export function formatCostPerSlide(
  costUsd: number,
  slides: number,
  rate: number = DEFAULT_TWD_PER_USD
): string {
  return slides === 0 ? "—" : `${formatTwd(costUsd / slides, rate)}/slide`;
}
